"use client";
import React from "react";
import { Box, Container, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

const ATLAS_BLUE = "#1D8FDC";

const AtlasContinuitySection = () => {
  const { t, i18n } = useTranslation();
  const isArabic = i18n.language === "ar";

  return (
    <Box
      component="section"
      sx={{
        py: { xs: 3, sm: 3, md: 3 },
        backgroundColor: "#FFFFFF",
        direction: isArabic ? "rtl" : "ltr",
      }}
    >
      <Container maxWidth="lg">
        {/* Top - centered header */}
        <Box sx={{ textAlign: "center", mb: { xs: 5, md: 8 } }}>
          <Typography
            sx={{
              fontSize: { xs: "10px", sm: "11px" },
              fontWeight: 600,
              color: ATLAS_BLUE,
              letterSpacing: "1.5px",
              textTransform: "uppercase",
              fontFamily: "var(--font-outfit)",
              mb: { xs: 1.5, sm: 2 },
            }}
          >
            {t("atlasContinuity.label")}
          </Typography>

          <Typography
            variant="h2"
            sx={{
              fontSize: { xs: "24px", sm: "30px", md: "36px", lg: "40px" },
              fontWeight: 700,
              lineHeight: 1.25,
              color: "#14122B",
              fontFamily: "var(--font-plusjakarta)",
              mx: "auto",
              mb: { xs: 2, sm: 2.5 },
            }}
          >
            {t("atlasContinuity.heading.main")}{" "}
            <Box component="span" sx={{ color: ATLAS_BLUE }}>
              {t("atlasContinuity.heading.highlight")}
            </Box>
          </Typography>

          <Typography
            sx={{
              fontSize: { xs: "13px", sm: "14px", md: "14.5px" },
              color: "#55556E",
              lineHeight: 1.8,
              fontWeight: 400,
              fontFamily: "var(--font-outfit)",
              maxWidth: 730,
              mx: "auto",
            }}
          >
            {t("atlasContinuity.description")}
          </Typography>
        </Box>

        {/* Bottom - card */}
        <Box
          sx={{
            // maxWidth: 820,
            mx: "auto",
            backgroundColor: "#F6F2FF",
            border: "1px solid #EDE6FA",
            borderRadius: { xs: "16px", md: "20px" },
            px: { xs: 3, sm: 4, md: 5 },
            py: { xs: 4, md: 5 },
            display: "grid",
            gridTemplateColumns: { xs: "1fr", md: "1fr 1.3fr" },
            gap: { xs: 3, md: 6 },
            alignItems: "center",
          }}
        >
          <Box sx={{ textAlign: isArabic ? "right" : "left" }}>
            <Typography
              sx={{
                fontSize: { xs: "9px", sm: "10px" },
                fontWeight: 700,
                color: ATLAS_BLUE,
                letterSpacing: "1.5px",
                textTransform: "uppercase",
                fontFamily: "var(--font-outfit)",
                mb: { xs: 1.5, sm: 2 },
              }}
            >
              {t("atlasContinuity.card.label")}
            </Typography>

            <Typography
              variant="h3"
              sx={{
                fontSize: { xs: "22px", sm: "26px", md: "28px" },
                fontWeight: 700,
                lineHeight: 1.2,
                color: "#14122B",
                fontFamily: "var(--font-plusjakarta)",
              }}
            >
              {t("atlasContinuity.card.heading")}
            </Typography>
          </Box>

          <Typography
            sx={{
              fontSize: { xs: "13px", sm: "13.5px", md: "14px" },
              color: "#2E2B4A",
              lineHeight: 1.8,
              fontWeight: 400,
              fontFamily: "var(--font-outfit)",
              textAlign: isArabic ? "right" : "left",
            }}
          >
            {t("atlasContinuity.card.description")}
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default AtlasContinuitySection;